module.exports = __webpack_public_path__ + "img/skin-detail-use-functions-bg.8bbb77e.jpg";